<template>
    <section class="box-custom-repeater">

        <div v-if="integrations" class="title"> {{ data.tag }} </div>

        <div v-if="!integrations" class="loading">
            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
        </div>

        <form v-else class="field">
            <div
                v-for="field in setData" :key="field.id"
                :class="field.type == 'repeater' ? 'field-container-full' : 'field-container'"
            >
                <div v-if="['text', 'email', 'tel'].includes(field.type) && field.options?.desktop?.mask != 'mask-money'" class="field-container-input">
                    <ui-input
                        v-model="setForm[field.id]"
                        :label="field.name"
                        :type="field.type"
                        :error="field.hasError"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        :mask="setMask(field.options.desktop.mask ? field.options.desktop.mask : null, setForm[field.id], field.id, field.name)"
                        :placeholder="field.placeholder"
                        :observation="field.observation"
                        @input="validateFields()"
                        @verify="(a,b)=> validateField(a , b, field.options.desktop.mask ? field.options.desktop.mask : null, field.id, field.type, field.name)"
                    />
                </div>

                <div v-if="field.type === 'textarea'" class="field-container-textArea">
                    <ui-textarea
                        v-model="setForm[field.id]"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        :placeholder="field.placeholder"
                        @input="validateFields()"
                    />
                </div>

                <div v-if="field.type === 'select' && field.options.informakon !== 'product' && field.options.informakon !== 'integration' && field.options.informakon !== 'unit' && integrations" class="field-container-select">
                    <ui-select-v2
                        v-model="setForm[field.id]"
                        design="mgb-15 br-all"
                        :search="false"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        placeholder="Selecione"
                        :data="field.options.options"
                        return-value="label"
                        @input="validateFields()"
                    />
                </div>

                <div v-if="field.type === 'select' && field.options.informakon === 'integration'" class="field-container-select">
                    <ui-select-v2
                        v-model="setForm[field.id]"
                        design="mgb-15 br-all"
                        :search="false"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        placeholder="Selecione"
                        :data="integrations"
                        return-value="value"
                        @input="validateFields(), getProductsInformakon(field.id)"
                    />
                </div>

                <div v-if="field.type === 'select' && field.options.informakon === 'product' && integrations" class="field-container-select">
                    <ui-select-v2
                        v-model="setForm[field.id]"
                        :disabled="!products"
                        design="mgb-15 br-all"
                        :loading="loadProducts"
                        :search="false"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        placeholder="Selecione"
                        :data="products"
                        @input="validateFields(), getUnitsInformakon(field.id)"
                    />
                </div>

                <div v-if="field.type === 'select' && field.options.informakon === 'unit' && integrations" class="field-container-select">
                    <ui-select-v2
                        v-model="setForm[field.id]"
                        design="mgb-15 br-all"
                        :disabled="!units"
                        :loading="loadUnits"
                        :search="false"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        placeholder="Selecione"
                        :data="units"
                        @input="validateFields()"
                    />
                </div>

                <div v-if="field.type === 'date'" class="field-container-calendar">
                    <ui-datepicker
                        v-model="setForm[field.id]"
                        :label="field.name === 'Data de Nascimento/Data de Fundação' ? 'Data de Fundação' : field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        :min-date="false"
                        :context="'notFuture'"
                        @input="validateFields()"
                    />
                </div>

                <div v-if="field.type === 'money' || field.options?.desktop?.mask === 'mask-money'" class="field-container-input">
                    <ui-input-money
                        v-model="setForm[field.id]"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        color-value="#676767"
                        masked
                        @input="validateFields()"
                    />
                </div>

                <div v-if="field.type === 'radio'" class="field-radio">
                    <ui-radio
                        v-model="setForm[field.id]"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        :name="field.slug"
                        @input="validateFields()"
                    >
                        <option v-for="(value,index) in field.options.options" :key="index" :value="value">
                            {{ value }}
                        </option>
                    </ui-radio>
                </div>

                <div v-if="field.type === 'file'" class="field-container-file">
                    <ui-upload-files
                        :id="`${field.id}`"
                        :refer="`${field.id}`"
                        :label="field.name"
                        :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                        :placeholder="field.placeholder"
                        :field-slug="field.slug"
                        :set-docs="setForm[field.id]"
                        btn-remove
                        accept=".pdf,.png,.jpg,.doc,.docx,.xls,.xlsx,.jpeg"
                        @change="upload"
                        @remove="confirmDelete(field.slug, field.id)"
                    />
                </div>

                <div  v-if="field.type === 'repeater'" class="repeater">
                    <ui-button
                        v-if="dataTable[id] && dataTable[id].length > 0"
                        class="repeater-icon-small"
                        design="primary sm"
                        @click="openModalRepeater()"
                    >
                        <em class="fal fa-plus"/>
                    </ui-button>

                    <div v-else-if="!loading" class="repeater-icon" @click="openModalRepeater()">
                        <div class="icon">
                            <em class="fal fa-plus"/>
                        </div>
                    </div>

                    <ui-modal name="repeater-form" size="nm">
                        <repeater-inputs
                            :data="field.repeater"
                            @loading="loading = true"
                            @cancel="closeModalRepeater()"
                        />
                    </ui-modal>

                    <repeater-table :key="dataTableKey" :data="dataTable[id]"/>

                    <div v-if="loading" class="loader-save-repeater">
                        <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                    </div>
                </div>
            </div>
        </form>

        <ui-modal-message
            service="funnel"
            name="delete-dynamic"
            title="Deseja realmente excluir?"
            text="Cuidado, esta ação não poderá ser desfeita."
            btn-type="danger"
            btn-text="Confirmar"
        />
    </section>
</template>

<script>
    import {
        uiTextarea,
        uiRadio,
        uiInput,
        uiSelectV2,
        uiInputMoney,
        uiDatepicker
    } from '@/components/ui/form'
    import { uiUploadFiles, uiLoadIndicator } from '@/components/ui'
    import { uiModalMessage, uiModal } from '@/components/ui/modal'
    import { repeaterInputs, repeaterTable } from './repeater'
    import { uiButton } from '@/components/ui/buttons'

    import { files, erp } from '@/services/axios'

    import { helpersMixin, utilMixin } from '@/mixins'

    import { mapGetters } from 'vuex'

    const qs = require('qs')

    export default {
        name: 'page-customs',

        components: {
            uiTextarea,
            uiRadio,
            uiInput,
            uiSelectV2,
            uiInputMoney,
            uiDatepicker,
            repeaterInputs,
            uiUploadFiles,
            uiModalMessage,
            uiModal,
            repeaterTable,
            uiLoadIndicator,
            uiButton
        },

        mixins:[helpersMixin, utilMixin],

        props: {
            data: {
                type: Object,
                required: true
            },
            id: {
                type: Number,
                required: true
            },

            form: {
                type: [Object, Array],
                default: function () {
                return {}
                }
            }
        },
        emits: ['update:modelValue'],

        data (){
            return {
                setForm: {...this.form},
                required: null,
                setRepeater: true,
                dataTableRepeater: [],
                setData: null,
                loading: false,
                selectedFile: {},
                isValidEmail: true,
                isValidCPFOrCNPJ: true,
                isValidMobile:true,
                isValidPhone:true,
                dataTableKey: 0,
                integrationId: null,
                productCode: null,
                subsidiaryCode: null,
                productNumber:null,
                integrations:null,
                products: null,
                units:null,
                loadProducts: false,
                loadUnits: false
            }
        },

        computed: {
            ...mapGetters({
                dataTable: 'card/getDataTable',
        }),

        },

        created() {
            this.setData = this.sortObject(this.data.fields, 'position')
            this.required = Object.values(this.data.fields).map(field => {return {id: field.id, required: typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true}})
        },

        mounted() {
            /**
            * Deleta os dados dos campos do tipo file
            */
            this.$root.$on('delete-dynamic-success', (value) => {
                let id = null
                for (const attr in value.data) {
                    id = attr
                }
                this.setForm[id] = null
                this.validateFields()
                this.$root.$emit('confirm-delete-success', id)
            })
            /**
            * Recebe os dados do card
            */
            this.$root.$on('create-deal-modal-dynamic-saved', payload => {
                    if (payload?.data && Object.keys(payload.data).length > 0) {
                            let item = null
                            Object.entries(payload.data).forEach(el => {
                            item = el[1].filter((res, index) => {
                                return index == 0
                            })
                        })
                        this.dataTableRepeater.push(item[0].sended[0])
                    }
                     let id = null
                        for (const attr in payload.data) {
                            id = attr
                        }
                        this.setForm[id] = this.dataTableRepeater
                        this.forceRerender()
                        this.loading = false
                        this.$emit('input', true, this.setForm)
            })
            this.validateFields(this.id)
            this.getIntegrationInformakon()
        },

        beforeDestroy() {
            this.$root.$off('delete-dynamic-success')
            this.$root.$off('create-deal-modal-dynamic-saved')
            this.$root.$off('modal-open-repeater-form')
        },

        methods: {
             /**
            * Força a renderização da página
            */
            forceRerender() {
                this.dataTableKey += 1
            },
            /**
            *Define o tamanho dos campos
            */
            size (field) {
                return field?.limit ? '50%'  : '100%'
            },
            /**
            * Retorna a máscara de acordo com o tipo do campo
            */
            setMask(maskType, inputValue, id, name) {
                let item = null

                if (maskType === 'mask-cep') {
                    item = '#####-###'
                } else if (maskType === 'mask-phone' && name === 'Telefone') {
                    item = '(##) ####-####'
                } else if (maskType === 'mask-phone' || name === 'Celular') {
                    item = '(##) #####-####'
                } else if (maskType === 'mask-cpf' || maskType === 'mask-cnpj') {
                    // Determine if input is CPF or CNPJ and set mask accordingly
                    const isCPF = inputValue && inputValue.replace(/\D/g, '').length === 11
                    item = isCPF ? '###.###.###-##' : '##.###.###/####-##'

                }

                return item
            },
            cancel(val) {
                this.setRepeater = val
            },
            /**
            * Valida os campos required do formulário
            */
            validateFields() {
                const requiredFields = this.required.filter(field => { return field.required })
                const isFieldFilled = requiredFields.map(field => this.$mx_hasValue(this.setForm[field.id]))
                let canSubmit = isFieldFilled.every(filled => filled)
                if(!this.isValidCPFOrCNPJ || !this.isValidEmail || !this.isValidMobile || !this.isValidPhone){
                    canSubmit = false
                }
                this.$emit("input", canSubmit, this.setForm)
            },

            validateFilesDoc() {
                const requiredFields = this.required.filter(field => { return field.required })
                const isFieldFilled = requiredFields.map(field => this.$mx_hasValue(this.setForm[field.id]))
                const canSubmit = isFieldFilled.every(filled => filled)
                this.$emit("input", canSubmit, this.setForm)
            },
            /**
            * Salva as imagens do campo do tipo file
            */
            upload(obj) {
                const fd = new FormData()
                if(obj?.event?.target?.files?.[0]) {
                    fd.append('file', obj.event.target.files[0])
                    fd.append('name', obj.slug)
                    files.create('', fd).then(response => {
                        let params = {name:obj.slug, [`field_value[${obj.id}][file_id]`]: response.data[0].file.id}
                        this.$root.$emit('save-dynamic-data-table', qs.stringify({ ...params }))
                        this.validateFilesDoc()
                    })
                    let reader = new FileReader()
                    this.setForm[obj.id] = {base64: '', name: '', id: ''}
                    reader.addEventListener('load', () => {
                        this.setForm[obj.id]['base64'] = reader.result
                    })
                    reader.readAsDataURL( obj.event.target.files[0])
                    this.setForm[obj.id]['name'] = obj.event.target.files[0].name
                    this.setForm[obj.id]['id'] = obj.id
                }
            },
            /**
            * Deleta as imagens do campo do tipo file
            */
            confirmDelete(name, id) {
                let params = { name:name, [`field_value[${id}][file_id]`]: 'destroy' }
                let data = {
                    method: 'updateDataFieldDynamic',
                    id: '',
                    url: '',
                    formdata: qs.stringify({ ...params }),
                    eventSuccess: 'datatable-reload-pageCustoms',
                    errorText: 'Não foi possível executar esta ação.'
                }
                this.$root.$emit('delete-dynamic-data-table', data)
            },
            /**
            * Abre o modal para preencimento dos campos do repeater
            */
            openModalRepeater() {
                this.$root.$emit('modal-open-repeater-form')
            },
            /**
            * Fecha o modal para preencimento dos campos repeater
            */
            closeModalRepeater() {
                this.$root.$emit('modal-close-repeater-form')
            },
            /**
            * Valida os campos do tipo email, CPF e CNPJ
            */
            validateField(event , inputValue, inputMask, id, type, name) {
                this.isValidEmail = inputValue === '' || event
                this.isValidMobile = inputValue === '' || event
                this.isValidPhone = inputValue === '' || event
                const indexField = this.setData.findIndex(field => field.id === id)
                let messageError = ''
                let hasError = false

                if(inputMask === 'mask-cpf' || inputMask === 'mask-cnpj') {
                    const isCPF = inputValue && inputValue.replace(/\D/g, '').length === 11
                    let isValidCPFOrCNPJ = isCPF ? this.$mx_validateCPF(inputValue) : this.$mx_validateCNPJ(inputValue)

                    this.isValidCPFOrCNPJ = isValidCPFOrCNPJ

                    if(!this.isValidCPFOrCNPJ && !inputValue || this.isValidCPFOrCNPJ && inputValue ) {
                        if(!inputValue) {
                            this.isValidCPFOrCNPJ = true
                        }
                        hasError = false
                        messageError = ''
                    }else if(!this.isValidCPFOrCNPJ && inputValue){
                        hasError = true
                        messageError = 'Digite um CPF ou CNPJ válido.'
                    }
                } else  if(!this.isValidEmail && type === 'email') {
                    hasError = true
                    messageError = 'Digite um email válido.'
                } else if(!this.isValidMobile && name === 'Celular' || !this.isValidPhone && name === 'Telefone' ) {
                    hasError = true
                    messageError = 'Digite um número válido.'
                }
                else {
                    hasError = false
                    messageError = ''
                }

                if(indexField !== -1) {
                    this.$set(this.setData[indexField], 'hasError', hasError)
                    this.$set(this.setData[indexField], 'observation', messageError)
                }

            },
            async getIntegrationInformakon() {
                await erp.getIntegrations()
                    .then((response) => {
                        this.integrations = Object.values(response.data.data)
                            .filter(integration => integration.type === 'informakon')
                            .map(integration => ({label: integration.business_name, value: integration.id }))
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
            async getProductsInformakon(id) {
                this.loadProducts = true
                if (this?.setForm[id]) {
                    await erp.getProducts(this.setForm[id])
                    .then((response) => {
                        this.products = Object.values(response.data.data).map(product => (
                            {
                                label:product.empreendimentoNome,
                                value:product.keyEmpreendimento,
                                data: {
                                    productCode:product.empresaCodigo,
                                    subsidiaryCode: product.filialCodigo,
                                    productNumber: product.empreendimentoNumero,
                                    integrationId:this.setForm[id]
                                }
                            })
                        )
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.loadProducts = false
                    })
                }
            },
            async getUnitsInformakon(id) {
                this.loadUnits = true
                let data = this.setForm[id].data
                await erp.getUnits(data)
                .then((response) => {
                    this.units = response.data
                    .map(unit => ({label: unit.identificacaoComEdificacao, value: unit.keyImovel}))
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                        this.loadUnits = false
                    })

        }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
